import {
    SET_BALANCE_HISTORY_PAGINATION_PAGE_SIZE,
    SET_BALANCE_HISTORY_PAGINATION_TOTAL_RECORDS
} from "../actions/pagination-actions";

const initialState = {
    billingTotalRecords: 0,
    pageSize: 15
}

export default function paginationReducer(state = initialState, {type, payload}) {

    switch(type) {

        case SET_BALANCE_HISTORY_PAGINATION_TOTAL_RECORDS: {
            return {
                ...state,
                billingTotalRecords: payload,
            }
        }

        case SET_BALANCE_HISTORY_PAGINATION_PAGE_SIZE: {
            return {
                ...state,
                pageSize: payload,
            }
        }

        default:
            return state
    }
}
